import { connect } from 'react-redux';
import ContainerlessButtonWidget from 'nucleus-widgets/lib/Button/ContainerlessButtonWidget';
import { routeToUrl, getPagePath } from '../../redux/modules/pathInfo';
import {
  getDefaultWebsitePageId, getCurrentPageId
} from '../../redux/modules/reducer';
import {
  isPostRegPage, isRegistrationPage, isRegistrationCancellationPage,
  isRegistrationPendingApprovalPage, isRegistrationApprovalDeniedPage
} from '../../redux/modules/selectors/pages';
import { logoutRegistrant } from '../../redux/modules/registrantLogin/actions';
import {
  showLoadingDialog, hideLoadingDialog, hideLoadingOnError
} from 'nucleus-guestside-site/src/redux/modules/dialogContainer';
import qs from 'querystring';

const stripInviteeFromUrl = (url) => {
  const path = url.split('?')[0];
  const query = qs.parse(url.split('?')[1]) || {};
  delete query.inviteeId;
  // The i query param is the incoded version of the inviteeId.
  delete query.i;
  // The tm query param store a hash for test mode
  delete query.tm;
  return path + (Object.keys(query).length ? `?${qs.stringify(query)}` : '');
};

function logout() {
  return async (dispatch, getState) => {
    dispatch(showLoadingDialog());
    const state = getState();
    const currentPageId = getCurrentPageId(state);
    const nextPageId = (isRegistrationPage(state, currentPageId) || isPostRegPage(state, currentPageId) ||
      isRegistrationCancellationPage(state, currentPageId)) ||
      isRegistrationPendingApprovalPage(state, currentPageId) ||
      isRegistrationApprovalDeniedPage(state, currentPageId)
      ? getDefaultWebsitePageId(state)
      : currentPageId;
    try {
      await dispatch(logoutRegistrant());
      if (state.userSession.isTestMode) {
        // setting href instead of using replace so that back button works correctly
        global.location.href = stripInviteeFromUrl(getPagePath(state, nextPageId));
      } else {
        await dispatch(routeToUrl(stripInviteeFromUrl(getPagePath(state, nextPageId))));
      }
    } catch (error) {
      dispatch(hideLoadingOnError());
      throw error;
    }
    dispatch(hideLoadingDialog());
  };
}

export function mapStateToProps() {
  return {
    kind: 'button'
  };
}
export const mapDispatchToProps = {
  clickHandler: logout
};

/**
* Data wrapper for the log out widget.
*/
export default connect(mapStateToProps, mapDispatchToProps)(ContainerlessButtonWidget);



// WEBPACK FOOTER //
// ./src/widgets/WebsiteNavigator/LogoutButtonWidget.js